
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/hydrology",
      function () {
        return require("private-next-pages/hydrology.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/hydrology"])
      });
    }
  